import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productionApi = createApi({
  reducerPath: "productionApi",
  baseQuery,
  tagTypes: ["productionDetails"],
  endpoints: (builder) => ({

    getProductionDetailsById: builder.query({
      query: ({id}) => `/export/product/productionDetails/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];

        // Ensure it's always an array
        const normalized = Array.isArray(data) ? data : [data];

        // Add `id` field from exportEntityId
        return normalized.map((item) => ({
          ...item,
          id: item.productionDetailsId,
        }));
      },
      providesTags: ["productionDetails"],
    }),

    createProductionDetail: builder.mutation({
      query: ({id , ...data}) => ({
        url: `/export/product/productionDetails/${id}`,
        method: "PUT", 
        body: { productionDetails:data },
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["productionDetails"],
    }),


    updateProductionDetail: builder.mutation({
      query: ({ id ,subId, ...data  }) => ({
        url: `/export/product/productionDetails/${id}/${subId}`,
        method: "PUT",
        body: { productionDetails:data},
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["productionDetails"],
    }),

    deleteProductionDetail: builder.mutation({
      query: ({id}) => ({
        url: `/export/product/productionDetails/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["productionDetails"],
    }),

  }),
});

export const {
  useLazyGetProductionDetailsByIdQuery,
  useCreateProductionDetailMutation,
  useUpdateProductionDetailMutation,
  useDeleteProductionDetailMutation,
} = productionApi;
